export default "__VITE_ASSET__e5a36ecc__"